import React, { useEffect, useState } from "react";
import PushNoticeCard from "../common/Cards/PushNoticeCard";
import { Col, Row } from "react-bootstrap";
import Flag from "../assets/images/flag.png";
import { _apiUrls } from "../utils/endpoints/apiUrls";
import { apiRequest } from "../utils/config/apiRequest";
import Pagination from "../common/Pagination";

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({ rows: [] });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [dashboardDataCount, setdashboardDataCount] = useState({})
  const itemsPerPage = 5;

  useEffect(() => {
    fetchUsers();
    fetchDashboardCount();
  }, [currentPage]);

  const fetchUsers = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getUser,
      method: "GET",
      query: {
        page: currentPage,
        limit: itemsPerPage,
      },
    });
    if (status) {
      setState({ ...state, rows: Array.isArray(data?.rows) ? data.rows : [] });
      setTotalItems(data?.count || 0);
    }
    setLoading(false);
  };

  const registerdCount = totalItems;

  const fetchDashboardCount = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.dashboardApiCounts,
      method: "GET",
    });
    if (status) {
      setdashboardDataCount(data?.rows);
    }
    setLoading(false);
  };


  const cardData = [
    {
      id: 1,
      title: dashboardDataCount?.todayPushNotice || 0,
      subtitle: "Today Push Notice",
      color: "#759dee",
      icon: <i className="fa fa-clock-o dashfonticon" aria-hidden="true"></i>,
    },
    {
      id: 2,
      title: dashboardDataCount?.upcomingPushNotice || 0,
      subtitle: "Upcoming Push Notice",
      color: "#F4A335",
      icon: (
        <i
          className="fa fa-calendar-plus-o dashfonticon"
          aria-hidden="true"
        ></i>
      ),
    },
    {
      id: 3,
      title: dashboardDataCount?.lastWeekPushNotice || 0,
      subtitle: "Last week Push Notice",
      color: "#63C276",
      icon: <i className="fa fa-bell-o dashfonticon" aria-hidden="true"></i>,
    },
    {
      id: 4,
      title: dashboardDataCount?.lastMonthPushNotice || 0,
      subtitle: "Last Month Push Notice",
      color: "#F25F84",
      icon: <i className="fa fa-bell-o dashfonticon" aria-hidden="true"></i>,
    },
    {
      id: 5,
      title: dashboardDataCount?.registeredUsers || 0,
      subtitle: "Registered",
      color: "#63C276",
      icon: <i className="fa fa-user-o dashfonticon" aria-hidden="true"></i>,
    },
  ];




  return (
    <>
      <Row>
        <Col md={12} className="py-3">
          <h4 className="dashheading">Dashboard</h4>
          <p className="dashsubheading">Overview</p>
        </Col>

        {cardData.map((item, index) => (
          <Col md={3} className="">
            <PushNoticeCard
              icon={item.icon}
              title={item.title}
              subtitle={item.subtitle}
              bgColor={item.color}
            />
          </Col>
        ))}

        <Col md={12} className="mt-3">
          <div className="table-responsive">
            <table hover className="admintable ">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>User Id</th>
                  <th>User Detail</th>
                  <th>Email Id</th>
                  <th>Country</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      <div className="d-flex justify-content-center align-items-center">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : state.rows.length > 0 ? (
                  state.rows.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.memberId || "987656"}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          {item?.profilePic ? (
                            <img
                              src={
                                item?.profilePic?.startsWith("http")
                                  ? item.profilePic
                                  : `${process.env.REACT_APP_API_ORIGIN}/${item?.profilePic?.replace(/^\/+/, "")}`
                              }
                              alt=""
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <div className="user-pic">
                              <p className="mb-0">
                                {(item?.fullName || "NA")
                                  .substring(0, 2)
                                  .toUpperCase()}
                              </p>
                            </div>
                          )}
                          <div>
                            <strong>{item?.fullName}</strong>
                            <br />
                            <span style={{ fontWeight: 500, fontSize: "11px" }}>
                              {item?.mobile}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>{item?.email}</td>
                      <td>{item?.country?.name || "----"}</td>
                      <td>
                        <span
                          className={`badge badge-status ${item.status === "active"
                              ? "bg-success"
                              : "badge-danger"
                            }`}
                        >
                          {item?.status?.charAt(0).toUpperCase() +
                            item?.status?.slice(1)}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>

        <Col md={12}>
          <p className="tablebottomText">
            {" "}
            <img src={Flag} height="18px" alt="" className="me-1" /> Russian
            user data is processed and stored in accordance with the legal
            requirements of the Russian Federation (Federal Law No. 152-FZ).
          </p>
        </Col>

        <Col md={12} className="text-end">
          <div className="d-flex justify-content-end">
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
